import React, { useState, useEffect } from "react";
import { Row, Col, Container, Spinner, Alert } from "react-bootstrap";
import apiCall from "../Api/api";
import parse from 'html-react-parser';

const FaqQuestion = () => {
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        const response = await apiCall({
          url: `faqs`,
          method: "GET",
          headers: "",
        });

      

        if (response?.status === 200) {
          const responseData = Array.isArray(response.data)
            ? response.data
            : response.data.faqs;
          setFaqData(responseData || []);
        } else {
          throw new Error("Failed to load FAQs. Please try again.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <section className="faqs-wrpper margin_bottomfooter pt-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" style={{color: "#09422d",}} />
              </div>
            ) : error ? (
              <Alert variant="danger">{error}</Alert>
            ) : (
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {faqData.map((faq, index) => (
                  <div className="accordion-item mb-3" key={faq.id || index}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-${faq.id || index}`}
                        aria-expanded="false"
                        aria-controls={`flush-${faq.id || index}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      className="accordion-collapse collapse"
                      id={`flush-${faq.id || index}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      {faq.answer && parse(faq.answer)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FaqQuestion;
